
export const common = {
  'call.us': '전화하기',
  'privacy.policy': '개인정보 처리방침',
  'select.location': '위치 선택',
  'location.description': '적절한 번호로 전화하기 위해 위치를 선택하세요',
  'usa': '미국',
  'non.usa': '미국 외 전화 또는 WhatsApp',
  'documents.downloads': '문서 및 다운로드',
  'item': '항목',
  'value': '값',
  'price': '가격',
  'product': '제품',
  'msrp': '권장소비자가격',
};
